module.exports = __webpack_public_path__ + "img/球员人才库.37d2397d.png";